import { STAGE_LABELS } from './stageLabels';

interface StagePayload {
  active: boolean;
  description: string;
  points: Array<{ text: string }>;
  domainId: number;
  skillIds?: number[];
}

interface ActivityPayload {
  title: string;
  stages: StagePayload[];
}

export function validateActivityPayload(data: ActivityPayload): Record<string, string> {
  const errors: Record<string, string> = {};

  if (!data.title.trim()) errors.title = 'Title is required';

  data.stages.forEach((stage, i) => {
    if (!stage.active) return;
    const label = STAGE_LABELS[i] ?? `Stage ${i + 1}`;

    if (!stage.description.trim()) {
      errors[`stages.${i}.description`] = `${label} — description is required`;
    }
    if (!stage.points.length) {
      errors[`stages.${i}.points`] = `${label} — at least one point is required`;
    }
    if (!stage.domainId) {
      errors[`stages.${i}.domainId`] = `${label} — domain is required`;
    }
    if (!stage.skillIds?.length) {
      errors[`stages.${i}.skillIds`] = `${label} — at least one skill is required`;
    }
  });

  return errors;
}
